class CopyLink extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }
  connectedCallback() {
    this.href = this.getAttribute("href");
    this.addEventListener("click", this.handleClick);
    this.addEventListener("keydown", this.handleKeydown);
  }
  async handleClick(e) {
    e.preventDefault();
    if (!navigator.clipboard) return;
    try {
      await navigator.clipboard.writeText(this.href);
    } catch (err) {
    }
  }
  handleKeydown(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.click();
    }
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
    this.removeEventListener("keydown", this.handleKeydown);
  }
}
if (!customElements.get("copy-link")) {
  customElements.define("copy-link", CopyLink);
}
